import { ModuleState } from "components/Shared/GlobalFilter/context/interfaces"
import {
	disabledMetric,
	enabledModules,
} from "components/Shared/Filters/modules/Segmentation/constants"
import { MetricName } from "components/Transactional/Performance/components/MetricsSelect/interfaces"
import { Location } from "history"

export const isDisabledTypeOfCustomer = (
	modules: ModuleState,
	location: Location<unknown>
): boolean => {
	const {
		transactional: {
			benchmark: { metric },
		},
	} = modules
	return (
		!enabledModules.includes(location.pathname) ||
		disabledMetric[metric as MetricName]
	)
}
